import maplibregl from "maplibre-gl";
import type { MapEngine } from "./MapEngine";
import { MapLibreEngine } from "./MapLibreEngine";
import type { EngineOptions } from "./types";

/**
 * Creates a MapEngine backed by MapLibre GL JS.
 *
 * This is the only place the viewer instantiates a map. Callers receive the
 * renderer-agnostic {@link MapEngine} interface; the concrete MapLibre type is
 * not exposed (use `engine.getMap()` for the rare escape-hatch case).
 *
 * MapLibre requires no access token (unlike Mapbox GL), so none is set here.
 */
export function createEngine(options: EngineOptions): MapEngine {
    const map = new maplibregl.Map({
        container: options.container,
        // MapLibre accepts a style spec object or a URL string; the viewer
        // always passes a JSON object (or null to start empty).
        style: (options.style ?? undefined) as maplibregl.StyleSpecification | undefined,
        center: [options.camera.lng, options.camera.lat],
        zoom: options.camera.zoom,
        pitch: options.camera.pitch,
        bearing: options.camera.bearing,
        // Compact attribution: collapses the default full-width bar into a small
        // expandable "i" button, matching the prod viewer's clean look.
        attributionControl: { compact: true },
    });
    return new MapLibreEngine(map);
}
